import { createStructuredSelector } from 'reselect';
import { formValueSelector, getFormValues, } from 'redux-form' // ES6;
import { FORM_NAME_STEP1, FORM_NAME_STEP2, FORM_NAME_STEP3, FORM_NAME_STEP4, FORM_NAME_STEP5, FORM_NAME_STEP6 } from './constants';

const selector = formValueSelector(FORM_NAME_STEP1);
export const getFormValuesStep1 = (state) => getFormValues(FORM_NAME_STEP1)(state);
export const getFormValuesStep2 = (state) => getFormValues(FORM_NAME_STEP2)(state);
export const getFormValuesStep3 = (state) => getFormValues(FORM_NAME_STEP3)(state);
export const getFormValuesStep4 = (state) => getFormValues(FORM_NAME_STEP4)(state);
export const getFormValuesStep5 = (state) => getFormValues(FORM_NAME_STEP5)(state);
export const getFormValuesStep6 = (state) => getFormValues(FORM_NAME_STEP6)(state);
export const getFormId = (state) => FORM_NAME_STEP1;
export const getActiveStep = (state) => state.localReducer.step;
export const getTotalSteps = (state) => state.localReducer.steps;
export const getFormValid = (state) => state.localReducer.formValid;
export const getSnackBar = (state) => state.localReducer.showSnackBar;
export const getIdFormulario = (state) => state.localReducer.idFormulario;
export const getOpenModal = (state) => state.localReducer.openModal;
export const getDataEmpSubsidio = (state) => state.localReducer.dataEmpSubsidio;
export const getDynamicOptions = (state) => state.localReducer.dynamicOptions;
export const getReferenceFiles = (state) => state.localReducer.referenceFiles;
export const getDynamicDisable = (state) => state.localReducer.dynamicDisable;
export const getActivateRadio = (state) => state.localReducer.activateRadio;
export const getHiddenDisable = (state) => state.localReducer.hiddenDisable;
export const getContactoAdd = (state) => state.localReducer.contactoAdd;
export const getAuthError = (state) => state.localReducer.error;
export const getReloadPage = (state) => state.localReducer.reloadPage;
export const getHiddenClose = (state) => state.localReducer.hiddenClose;
export const getFormInitialized = (state) => state.localReducer.formInitialized;
export const getUserId = (state) => state.localReducer.userid;
export const getFormFiles = (state) => state.localReducer.formFiles;
export const getFormFirmas = (state) => state.localReducer.formFirmas;
export const getCharged = (state) => state.localReducer.charged;
export const getCatalogosCargados = (state) => state.localReducer.catalogos;
export const getChargedValidator = (state) => state.localReducer.chargedValidator;
export const getOptionsTable = (state) => state.localReducer.optionsTable;
export const getAddRecursoAhorro = (state) => state.localReducer.addRecursoAhorro;
export const getAddRecursoComplementario = (state) => state.localReducer.addRecursoComple;
export const getbase64Add = (state) => state.localReducer.base64Add;
export const getHoodId = (state) => state.localReducer.hoodId;
export const getInitValidate = (state) => state.localReducer.initValid;
export const getAnexosStorage = (state) => state.localReducer.anexosStorage;
export const getRefFiles = (state) => state.localReducer.refFiles;
export const getRefFirmas = (state) => state.localReducer.refFirmas;
export const getGeneratePdf = (state) => state.localReducer.generatePdf;
export const getReloadPdf = (state) => state.localReducer.reloadPdf;
export const getStep3Completo = (state) => state.localReducer.step3completo;
export const getMessage = (state) => state.localReducer.message;
export const getItemSaved = (state) => state.localReducer.itemSaved;
export const getOptionsInthogar = (state) => state.localReducer.optionsInthogar;
export const getEnabledDidabledArray = (state) => state.localReducer.enableDisableArray;
export const getRebootFiles = (state) => state.localReducer.rebootFiles;
export const getCatalogoCiclos = (state) => state.localReducer.catalogoCiclos;
export const getIntegrantesObligatorios = (state) => state.localReducer.integrantesObligatorios;
export const getInthObligatorios = (state) => state.localReducer.inthObligatorios;
export const getModalChargedEspera = (state) => state.localReducer.modalChargedEspera;
export const getFirebaseUser = (state) => state.localReducer.firebaseUser;
export const getFirebaseUserInfo = (state) => state.localReducer.firebaseUserInfo;
export const getUserColaborador = (state) => state.localReducer.userColaborador;
export const getEnabledAnexos = (state) => state.localReducer.enabledAnexos;
export const getFilesAnexosResources = (state) => state.localReducer.filesAnexosResources;
export const getActionTableAnexos = (state) => state.localReducer.actionTableAnexos;
export const getUpdateUploadFile = (state) => state.localReducer.updateUploadFile;
export const getOpenTabFrameVideo = (state) => state.localReducer.openTabFrameVideo;
export const getOpenFrameVideo = (state) => state.localReducer.openFrameVideo;
export const getListVideoFrame = (state) => state.localReducer.listVideoFrame;
export const getFirmaLabel = (state) => state.localReducer.firmaLabel;
export const getModalCloseForm = (state) => state.localReducer.modalCloseForm;
export const getMessageAlert = (state) => state.localReducer.messageAlert;
export const getSalarioMin = (state) => state.localReducer.salarioMin;
export const getActivatedAnexos = (state) => state.localReducer.activatedAnexos;

//apartir de aqui actualizacion
export const getFormUpdateActive = (state) => state.localReducer.formUpdateActive;
export const getCollectionVivienda = (state) => state.localReducer.collectionVivienda;
export const getInitDisableBandeja = (state) => state.localReducer.initDisableBandeja;
export const getEditResourses = (state) => state.localReducer.editResourse;
export const getDataFormUpdate = (state) => state.localReducer.dataFormUpdate;
export const getFinaliceUpdate = (state) => state.localReducer.finaliceUpdate;
export const getDataOportunidadConsulta = (state) => state.localReducer.dataConsultaOportunidad;
export const getOpenModalInstruccion = (state) => state.localReducer.openInstruccionFom;
export const getOpenConfirmaInstruccion = (state) => state.localReducer.openConfirmaInstruccion;
export const getFormBandeja = (state) => state.localReducer.formBandeja;
export const getFormDevolucion = (state) => state.localReducer.formDevolucion;
export const getUserInfoBandeja = (state) => state.localReducer.userInfoBandeja;
export const getUserInfoActualizacion = (state) => state.localReducer.userInfoActualizacion;
export const getTempRefFiles = (state) => state.localReducer.tempRefFiles;
export const getFileTemp = (state) => state.localReducer.fileTemp;
export const getActiveConsultaPlanes = (state) => state.localReducer.activeConsultaPlanes;
export const getOcultaAnexos = (state) => state.localReducer.ocultaAnexos;

export const getCompanyValuesStep1 = (state) => getFormValues("informacionBasicaStep1")(state);
export const getCompanyValuesStep2 = (state) => getFormValues("conformacionHogarStep2")(state);

export const getCompanyValuesStep4 = (state) => getFormValues("recursosEconomicosStep4")(state);
export const getCompanyValuesStep3 = (state) => getFormValues("postulacionStep3")(state);

export const getUpdateIngreStep2 = (state) => state.localReducer.ingreStep2;
export const getUpdateIngreStep4 = (state) => state.localReducer.ingreStep4;

export const favoriteColorValue = (state) => selector(state, 'favoriteColor');

export const fullFormSelector = createStructuredSelector({
    step1: getFormValuesStep1,
    step2: getFormValuesStep2,
    step3: getFormValuesStep3,
    step4: getFormValuesStep4,
    step5: getFormValuesStep5,
    step6: getFormValuesStep6
});